import styled, { css } from 'styled-components';
import { Card, mediaMixin, spaceMixin } from '@zillow/constellation';

export const StyledTitle = styled.div`
  width: 100%;
  max-width: 440px;
  text-align: center;
`;

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${mediaMixin(
    'md',
    css`
      flex-direction: row;
    `,
  )};
`;

export const StyledCardText = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: ${spaceMixin('sm')} 0;
  text-align: center;
  ${mediaMixin(
    'md',
    css`
      text-align: left;
      padding: 0 ${spaceMixin('sm')};
    `,
  )};
`;
